/**
 * Dynamic public path for Webpack
 */
__webpack_public_path__ = window.publicPath; // eslint-disable-line no-undef, camelcase
window.feVersionDetails = {
  tag: __VERSION_TAG__, // eslint-disable-line no-undef
  sha: __VERSION_SHA__, // eslint-disable-line no-undef
  time: __VERSION_DATE__, // eslint-disable-line no-undef
};
